// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-sidebar__desktop .streaming-chart{margin-top:24px}.title-sidebar__quick-action-bar{background:#1c252f;margin-bottom:8px}[dir=ltr] .title-sidebar__quick-action-bar{border-bottom-left-radius:4px}[dir=ltr] .title-sidebar__quick-action-bar,[dir=rtl] .title-sidebar__quick-action-bar{border-bottom-right-radius:4px}[dir=rtl] .title-sidebar__quick-action-bar{border-bottom-left-radius:4px}.title-sidebar .title-info{margin-top:20px;padding-top:20px;border-top:1px solid #1c252f}", ""]);
// Exports
module.exports = exports;
